import CheckinTicketsModal from './CheckinTicketsModal';

export default CheckinTicketsModal;
